export const STATUS_META = {
  DRAFT: { label: "Rascunho", cls: "bg-slate-100 text-slate-700" },
  PENDING_APPROVAL: { label: "Pendente", cls: "bg-amber-100 text-amber-800" },
  APPROVED: { label: "Aprovado", cls: "bg-emerald-100 text-emerald-800" },
  REJECTED: { label: "Ajuste Solicitado", cls: "bg-rose-100 text-rose-800" },
  SCHEDULED: { label: "Programado", cls: "bg-blue-100 text-blue-800" },
  PUBLISHED: { label: "Publicado", cls: "bg-indigo-100 text-indigo-800" },
};

export const MODE_META = {
  REAL: { label: "REAL", cls: "bg-emerald-500/10 text-emerald-600 border-emerald-500/30" },
  CONNECTED: { label: "CONECTADO", cls: "bg-emerald-500/10 text-emerald-600 border-emerald-500/30" },
  SANDBOX: { label: "SANDBOX", cls: "bg-sky-500/10 text-sky-600 border-sky-500/30" },
  MOCK: { label: "MOCK", cls: "bg-amber-500/10 text-amber-600 border-amber-500/30" },
  PLANEJADO: { label: "PLANEJADO", cls: "bg-slate-500/10 text-slate-500 border-slate-400/30" },
};

export const CHANNELS = ["Instagram", "Facebook", "Google Business", "WhatsApp", "YouTube", "YouTube Shorts", "TikTok"];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  owner: "Proprietário",
  admin: "Administrador",
  marketing: "Marketing",
  editor: "Editor",
  approver: "Aprovador",
  viewer: "Visualizador",
};

export const PILLARS = ["Educativo", "Dica prática", "Mitos e verdades", "Sinais de alerta", "Família e apoio",
  "Bastidores", "Depoimento", "Perguntas frequentes", "Novidade/Oferta"];

export const PILLAR_CLS = {
  "Educativo": "bg-sky-50 text-sky-700",
  "Dica prática": "bg-emerald-50 text-emerald-700",
  "Mitos e verdades": "bg-violet-50 text-violet-700",
  "Sinais de alerta": "bg-rose-50 text-rose-700",
  "Família e apoio": "bg-pink-50 text-pink-700",
  "Bastidores": "bg-slate-100 text-slate-700",
  "Depoimento": "bg-amber-50 text-amber-700",
  "Perguntas frequentes": "bg-teal-50 text-teal-700",
  "Novidade/Oferta": "bg-indigo-50 text-indigo-700",
};
